import axios from "axios";
import { serverApi, serverUrl } from "../confing/confing";
let token = localStorage.getItem("token");

export const GetAllAdminExperts = (limit, page) => {
  const url = `${serverUrl}/admin/experts?limit=${limit}&page=${page}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const searchExperts = (limit, page, search) => {
  const url = `${serverUrl}/admin/experts?limit=${limit}&page=${page}&q=${search}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const getInfoExpert = (id) => {
  const url = `${serverApi}/expert/${id}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const GetAllAdminUsers = (limit, page) => {
  const url = `${serverUrl}/admin/users?limit=${limit}&page=${page}&q=`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const searchUsers = (limit, page, search) => {
  const url = `${serverUrl}/admin/users?limit=${limit}&page=${page}&q=${search}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const getAdminStatistics = () => {
  const url = `${serverUrl}/admin/statistics`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};

export const getAdminExpertWallet = (id) => {
  const url = `${serverApi}/admin/expert-wallet/${id}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const clearingPriceExpertWallet = (sendData) => {
  let token = localStorage.getItem("token");
  const url = `${serverUrl}/admin/clearing`;
  return axios.post(url, sendData, {
    headers: { authorization: `Bearer ${token}` },
  });
};
export const sendTicket = (sendData) => {
  let token = localStorage.getItem("token");
  const url = `${serverApi}/noti`;
  return axios.post(url, sendData, {
    headers: { authorization: `Bearer ${token}` },
  });
};
export const editExpert = (values) => {
  const url = `${serverApi}/expert`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddExperts = (values) => {
  const url = `${serverApi}/expert`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const chackUserName = (values) => {
  const url = `${serverApi}utils/checkUname`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const GetAllAdminReports = (limit, page) => {
  const url = `${serverUrl}/admin/reports?limit=${limit}&page=${page}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const GetAllAdminTickets = (limit, page) => {
  const url = `${serverApi}ticket?limit=${limit}&page=${page}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};
export const GetAllAdminTicket = (id) => {
  const url = `${serverApi}ticket/${id}`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};

export const AdminAllRequests = (limit, page) => {
  const url = `${serverUrl}/admin/requests?limit=${limit}&page=${page}`;
  console.log(url);
  return axios.get(url, { headers: { authorization: `Bearer ${token}` } });
};

export const AddRealEstateAdmin = (values) => {
  const url = `${serverApi}admin/realState`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddPoints = (values) => {
  const url = `${serverApi}setting/point`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const deletePoint = (id) => {
  const url = `${serverApi}setting/point/${id}`;
  return axios.delete(url, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const editPoints = (values) => {
  console.log(values)
  const url = `${serverApi}setting/point`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddPrice = (values) => {
  const url = `${serverApi}setting/price`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const deletePrice = (id) => {
  const url = `${serverApi}setting/price/${id}`;
  return axios.delete(url, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const editPricing = (values) => {
  const url = `${serverApi}setting/price`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddDescription = (values) => {
  const url = `${serverApi}setting/description`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const deleteDescription = (id) => {
  const url = `${serverApi}setting/description/${id}`;
  return axios.delete(url, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const editDescription = (values) => {
  const url = `${serverApi}setting/description`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddMoreDescription = (values) => {
  const url = `${serverApi}setting/description`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const deleteMoreDescription = (id) => {
  const url = `${serverApi}setting/description/${id}`;
  return axios.delete(url, {
    headers: { authorization: `Bearer ${token}` },
  });
};
export const editMoreDescription = (values) => {
  const url = `${serverApi}setting/description`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddZone = (values) => {
  const url = `${serverApi}setting/zone`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const editZone = (values) => {
  const url = `${serverApi}setting/zone`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const AddCategory = (values) => {
  const url = `${serverApi}setting/category`;
  return axios.post(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const editCategory = (values) => {
  const url = `${serverApi}setting/category`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const getTiming = () => {
  const url = `${serverApi}utils/timing`;
  return axios.get(url, {
    headers: { authorization: `Bearer ${token}` },
  });
};

export const EditTiming = (values) => {
  const url = `${serverApi}setting/timing`;
  return axios.put(url, values, {
    headers: { authorization: `Bearer ${token}` },
  });
};
